import { render, staticRenderFns } from "./Assistant.vue?vue&type=template&id=28301b64&scoped=true"
import script from "./Assistant.vue?vue&type=script&lang=js"
export * from "./Assistant.vue?vue&type=script&lang=js"
import style0 from "./Assistant.vue?vue&type=style&index=0&id=28301b64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28301b64",
  null
  
)

export default component.exports